import { Toggle } from './Toggle'
import { cn } from '@/lib/cn'

interface Props {
  value: 'ATIVO' | 'INATIVO'
  onChange: (next: 'ATIVO' | 'INATIVO') => void
  label?: string
  disabled?: boolean
  className?: string
}

/**
 * Switcher dedicado para ATIVO/INATIVO em forms de cadastro/edição
 * (regra global: status deve ser sempre toggle, nunca dropdown).
 *
 * Layout compacto, sem borda — apenas switch + texto inline.
 */
export function StatusToggle({ value, onChange, label = 'Status', disabled, className }: Props) {
  const isActive = value === 'ATIVO'
  return (
    <div className={cn('flex flex-col', className)}>
      {label && <label className="text-xs font-medium text-gray-700 mb-1">{label}</label>}
      <div className="inline-flex items-center gap-2 h-[34px]">
        <Toggle checked={isActive} onChange={(v) => onChange(v ? 'ATIVO' : 'INATIVO')} disabled={disabled} size="sm" />
        <span className="text-[12px] font-medium text-gray-700">
          {isActive ? 'ATIVO' : 'INATIVO'}
        </span>
      </div>
    </div>
  )
}
